import React from "react";
import "./ActivityCard.css";
import CoinImg from "../../assets/images/coiin.png";

const ActivityHistoryShimmer = () => {
  return (
    <div className="activityHistory__grid" aria-hidden="true">
      {Array.from({ length: 4 }).map((_, index) => (
        <div className="activityHistory__card" key={index}>
          <span
            className="dashboard-skeleton dashboard-skeleton--button"
            style={{ width: 50, height: 50, borderRadius: "50%", flexShrink: 0 }}
          />
          <div className="activityHistory__details">
            <span className="dashboard-skeleton dashboard-skeleton--line" style={{ width: "70%", height: 18 }} />
            <span className="dashboard-skeleton dashboard-skeleton--line" style={{ width: "55%", marginTop: 10 }} />
          </div>
          <div className="activityHistory__reward">
            <span className="dashboard-skeleton dashboard-skeleton--button" style={{ width: 20, height: 20, borderRadius: "50%" }} />
            <span className="dashboard-skeleton dashboard-skeleton--line" style={{ width: 42, marginTop: 8 }} />
          </div>
        </div>
      ))}
    </div>
  );
};

const ActivityHistory = ({
  items = [],
  selectedFilterLabel = "All Activities",
  pagination = {},
  currentPage = 1,
  onPageChange,
  isLoading = false,
}) => {
  const hasItems = Array.isArray(items) && items.length > 0;
  const totalPages = Number(pagination?.totalPages || 1);

  return (
    <section className="activityHistory">
      <div className="activityHistory__heading">
        <span className="activityHistory__title">Activity</span>
        <span className="activityHistory__filter">{selectedFilterLabel}</span>
      </div>

      {isLoading ? <ActivityHistoryShimmer /> : null}

      {!isLoading && !hasItems ? (
        <div className="activityHistory__empty">No coin activity available.</div>
      ) : null}

      {!isLoading && hasItems ? (
        <div className="activityHistory__grid">
          {items.map((activity) => (
            <div className="activityHistory__card" key={activity.id}>
              <div
                className={`activityHistory__icon ${activity.isNegative ? "activityHistory__icon--negative" : ""}`}
              >
                <i className={`bi ${activity.isNegative ? "bi-arrow-down-right" : "bi-arrow-up-right"}`}></i>
              </div>

              <div className="activityHistory__details">
                <h3 className="activityHistory__name">{activity.activity}</h3>
                <p className="activityHistory__date">{activity.createdAt}</p>
              </div>

              <div className="activityHistory__reward">
                <div className="activityHistory__coin">
                  <img src={CoinImg} alt="Coin" />
                </div>

                <strong
                  className={`activityHistory__coins ${activity.isNegative ? "activityHistory__coins--negative" : ""}`}
                >
                  {activity.signedCoins}
                </strong>
              </div>
            </div>
          ))}
        </div>
      ) : null}

      {!isLoading && totalPages > 1 ? (
        <div className="activityHistory__pagination">
          <button
            type="button"
            className="activityHistory__pageButton"
            onClick={() => onPageChange?.(Math.max(1, currentPage - 1))}
            disabled={currentPage <= 1}
          >
            Previous
          </button>
          <span className="activityHistory__pageInfo">
            Page {currentPage} of {totalPages}
          </span>
          <button
            type="button"
            className="activityHistory__pageButton"
            onClick={() => onPageChange?.(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage >= totalPages}
          >
            Next
          </button>
        </div>
      ) : null}
    </section>
  );
};

export default ActivityHistory;
